module.exports = __webpack_public_path__ + "static/media/view2.bb62e45c.jpg";